const isProduction = process.env.REACT_APP_ENV === "production";
const isTest = process.env.REACT_APP_ENV === "test";

const frontendHostname = window.location.hostname as keyof typeof apiMappings;

const apiMappings: Record<string, string> = {
  "getmanagd.com": "https://api.getmanagd.com",
  "www.getmanagd.com": "https://api.getmanagd.com",
  "managd.ae": "https://api.managd.ae",
  "www.managd.ae": "https://api.managd.ae",
  "staging.getmanagd.com": "https://staging-api.getmanagd.com",
  "staging.managd.ae": "https://staging-api.managd.ae",
};

// Local API URL — only used in development when hostname is not mapped
const localApiUrl = `http://localhost:8585`;

// Safe lookup with fallback
export const API_URL =
  apiMappings[frontendHostname] ||
  (isProduction
    ? "https://api.getmanagd.com"
    : isTest
    ? "https://staging-api.getmanagd.com"
    : localApiUrl);

export const SPACES_ENDPOINT = isProduction
  ? "https://managd-production.fra1.digitaloceanspaces.com/"
  : "https://managd-staging.fra1.digitaloceanspaces.com/";

/**
 * Gebaeude, deren Eigentuemer im Portal ein Paket buchen duerfen.
 *
 * Eine bewusste Freigabeliste, kein Ableiten aus den Daten: ein Gebaeude wird
 * erst freigeschaltet, wenn Vertriebs- und Handover-Prozess dafuer stehen. Neue
 * Gebaeude kommen hier dazu, damit die Liste nicht an mehreren Stellen
 * auseinanderlaeuft.
 *
 * Die Freigabe allein genuegt nicht: die Wohnung erscheint erst, wenn das
 * Gebaeude entweder fertiggestellt ist oder in der Uebergabephase steht
 * (properties.handover). Ausserhalb der Produktion sind alle Gebaeude offen.
 */
export const PACKAGE_BOOKING_PROPERTY_IDS = [1, 2, 3, 4, 5];

export const canBookPackage = (propertyId: number): boolean =>
  !isProduction || PACKAGE_BOOKING_PROPERTY_IDS.includes(propertyId);

/**
 * Kann fuer diese Wohnung ein Paket gebucht werden?
 *
 * Drei Bedingungen: noch kein Verwaltungsvertrag, das Gebaeude ist freigegeben,
 * und es ist entweder fertiggestellt oder steht in der Uebergabephase.
 *
 * Jede Stelle, die in die Buchungsstrecke fuehrt, muss dasselbe fragen. Vorher
 * stand die Bedingung an sechs Stellen in fuenf Varianten, und eine davon
 * pruefte nur den fehlenden Vertrag: 361 von 494 Eigentuemern sahen dadurch
 * einen Banner, der auf eine Seite ohne buchbare Wohnung fuehrte.
 *
 * Der Handover-Banner im Dashboard-Header ist bewusst nicht hier: sein Text
 * nennt das Gebaeude, das "kurz vor Handover" steht, er verlangt also zwingend
 * die Uebergabephase und nicht nur ein fertiges Gebaeude.
 */
export const canBookPackageForUnit = (unit: {
  pm_contract?: unknown;
  property: { property_id: number; under_construction: boolean; handover: boolean };
}): boolean =>
  !unit.pm_contract &&
  canBookPackage(unit.property.property_id) &&
  ((unit.property.under_construction && unit.property.handover) ||
    !unit.property.under_construction);
